import { isDropshippingFlow, ProductUtils } from '@wix/package-picker-shared';
import { ProductCardList } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { ProductCard } from './ProductCard/ProductCard';
import { ProductCardsSkeleton } from './ProductCardsSkeleton';

export const ProductCards = () => {
  const isDropshippingIntent = isDropshippingFlow();

  return (
    <ProductCardList.Default.Root
      gap={12}
      useLoader={() => (
        <ProductCardsSkeleton numCards={isDropshippingIntent ? 3 : 4} />
      )}
      width="100%"
    >
      {({ products }) => {
        const sortedProducts = ProductUtils.sortProducts({ products });

        return sortedProducts.map((product) => {
          if (!product.productId) {
            return null;
          }

          return (
            <ProductCard
              key={product.productId}
              productId={product.productId}
            />
          );
        });
      }}
    </ProductCardList.Default.Root>
  );
};
